import { jsx as _jsx } from "react/jsx-runtime";
import { generateUUID } from '@nu-art/ts-common';
export function renderParticipantIcon(user, account) {
    if (user) {
        const acronym = generateUserAcronym(user, account?.email);
        return _jsx("div", { className: 'participant-icon', children: acronym }, generateUUID());
    }
    if (account) {
        return _jsx("div", { className: 'participant-icon', children: account.email.substring(0, 2).toUpperCase() }, generateUUID());
    }
    return _jsx("div", { className: 'participant-icon', children: "n/a" }, generateUUID());
}
export function generateUserAcronym(user, email) {
    if (user?.firstName && user?.surname)
        return `${user.firstName.at(0).toUpperCase()}${user.surname.at(0).toUpperCase()}`;
    if (!email)
        return 'n/a';
    return email.substring(0, 2).toUpperCase();
}
//# sourceMappingURL=const.js.map